import React from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import "./AboutUs/AboutUs.css";
import CTASection from "./CTASection";
import WhoWeAre from "./AboutUs/WhoWeAre";
import WhatWeDo from "./AboutUs/WhatWeDo";
import MissionVision from "./AboutUs/MissionVision";

const LearnMore = () => {
  return (
    <div className="learn-more-page">
      <Navbar />
      <WhoWeAre />
      <WhatWeDo />
      <MissionVision />
      <div className="section-container">
        <CTASection useContainer={false} />
      </div>
      <Footer />
    </div>
  );
};

export default LearnMore;
